import { FormattedMessage } from 'dibs-react-intl';
import { isNegotiableOrder } from '../helpers/checkoutRedirects';

function CheckoutTitle() {
    if (isNegotiableOrder()) {
        return (
            <FormattedMessage
                id="checkout.CheckoutTitle.completeOffer"
                defaultMessage="Complete Your Offer"
            />
        );
    }
    return (
        <FormattedMessage
            id="checkout.CheckoutTitle.secureCheckout"
            defaultMessage="Secure Checkout"
        />
    );
}

export default CheckoutTitle;
